import { Controller } from "@hotwired/stimulus";

const RECAPTCHA_SITE_KEY = "6LfhJ_stAAAAAJgePE1J-G8AjjIL3x64rKj2t3D_";

export default class extends Controller {
  static targets = [
    "yesInput",
    "noInput",
    "yesOption",
    "noOption",
    "details",
    "note",
    "nameField",
    "emailField",
    "token",
    "recaptchaAction",
  ];

  connect() {
    this.updateState();
    this.ensureRecaptcha();
  }

  selectYes(event) {
    event.preventDefault();

    if (this.hasYesInputTarget) {
      this.yesInputTarget.checked = true;
    }

    this.updateState();
  }

  selectNo(event) {
    event.preventDefault();

    if (this.hasNoInputTarget) {
      this.noInputTarget.checked = true;
    }

    this.updateState();
  }

  updateState() {
    const anonymous = this.hasNoInputTarget && this.noInputTarget.checked;

    if (this.hasDetailsTarget) {
      this.detailsTarget.hidden = anonymous;
    }

    if (this.hasNoteTarget) {
      this.noteTarget.hidden = !anonymous;
    }

    if (this.hasNameFieldTarget) {
      const nameField = this.nameFieldTarget;

      if (anonymous) {
        if (nameField.dataset.originalValue == null || nameField.dataset.originalValue === "") {
          nameField.dataset.originalValue = nameField.value;
        }

        nameField.value = "Anonymous";
        nameField.required = false;
      } else {
        nameField.required = true;

        if (nameField.value === "Anonymous") {
          nameField.value = nameField.dataset.originalValue || "";
        }
      }
    }

    if (this.hasEmailFieldTarget) {
      const emailField = this.emailFieldTarget;

      if (anonymous) {
        if (emailField.dataset.originalValue == null || emailField.dataset.originalValue === "") {
          emailField.dataset.originalValue = emailField.value;
        }

        emailField.value = "";
        emailField.disabled = true;
      } else {
        emailField.disabled = false;

        if (emailField.value === "") {
          emailField.value = emailField.dataset.originalValue || "";
        }
      }
    }

    this.updateChoiceStyles();
  }

  updateChoiceStyles() {
    if (this.hasYesOptionTarget) {
      this.setOptionState(this.yesOptionTarget, this.hasYesInputTarget && this.yesInputTarget.checked, false);
    }

    if (this.hasNoOptionTarget) {
      this.setOptionState(this.noOptionTarget, this.hasNoInputTarget && this.noInputTarget.checked, true);
    }
  }

  setOptionState(option, selected, anonymous) {
    option.style.background = selected ? "#eef8ef" : "#ffffff";
    option.style.fontWeight = selected ? "600" : "400";
    option.style.color = selected ? "#1b5e20" : "#111111";
    option.classList.toggle("reply-choice-option--selected", selected);
  }

  ensureRecaptcha() {
    if (window.grecaptcha?.enterprise != null) {
      this.loadRecaptchaToken();
      return;
    }

    if (window.contactUsRecaptchaLoading === true) return;

    window.contactUsRecaptchaLoading = true;

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.onload = () => {
      window.contactUsRecaptchaLoading = false;
      this.loadRecaptchaToken();
    };
    script.onerror = () => {
      window.contactUsRecaptchaLoading = false;
    };

    document.head.appendChild(script);
  }

  loadRecaptchaToken() {
    if (window.grecaptcha?.enterprise == null) return;

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: "feedback" }).then((token) => {
        if (this.hasTokenTarget) {
          this.tokenTarget.value = token;
        }

        if (this.hasRecaptchaActionTarget) {
          this.recaptchaActionTarget.value = "feedback";
        }
      });
    });
  }
}
